import React from 'react';
import '../styles/Testimonials.css';

function Testimonials() {
  const testimonials = [
    {
      quote:
        "FortIf has completely transformed our hiring process. We went from spending days manually screening resumes to finding top candidates in minutes. The AI is incredibly accurate and the bias-free screening gives us confidence in our decisions.",
      name: 'Sarah Chen',
      title: 'HR Manager',
      company: 'TechCorp Solutions',
      initials: 'SC',
    },
    {
      quote:
        "The contextual skill understanding is a game-changer. Unlike other tools that just match keywords, FortIf actually understands the nuances between similar technologies. This has helped us identify truly qualified candidates we would have missed before.",
      name: 'Michael Rodriguez',
      title: 'Recruitment Lead',
      company: 'InnovateLabs',
      initials: 'MR',
    },
    {
      quote:
        "As a talent acquisition director managing high-volume hiring, the bulk screening mode and AI copilot have saved our team countless hours. The explainable AI feature helps us trust the recommendations and makes interviewing much more focused.",
      name: 'Priya Sharma',
      title: 'Talent Acquisition Director',
      company: 'Global Enterprises Inc',
      initials: 'PS',
    },
  ];

  return (
    <section id="testimonials" className="testimonials section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2 className="section-title">Trusted by Hiring Teams Worldwide</h2>
          <p className="section-subtitle">
            See how FortIf is helping companies find better candidates faster with AI-powered
            resume screening.
          </p>
        </div>

        {/* Testimonial Cards */}
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card card">
              {/* Quote Icon */}
              <div className="quote-icon">"</div>

              {/* Quote Text */}
              <p className="testimonial-quote">{testimonial.quote}</p>

              {/* Author Info */}
              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.initials}</div>
                <div className="author-details">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-title">{testimonial.title}</div>
                  <div className="author-company">{testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
